export type VendedorLike = {
  nroVendedor: number;
  nombreVendedor?: string | null;
};

export const normalizeNroVendedor = (value?: number | null): number | null => {
  if (value == null || !Number.isFinite(value) || value <= 0) return null;
  return value;
};

export const formatVendedorLabel = (vendedor?: VendedorLike | null): string => {
  if (!vendedor?.nroVendedor) return '';
  const nombre = vendedor.nombreVendedor?.trim();
  return nombre ? `${vendedor.nroVendedor} - ${nombre}` : String(vendedor.nroVendedor);
};

export const filterVendedoresByTerm = (
  vendedores: VendedorLike[],
  searchTerm: string
): VendedorLike[] => {
  const trimmed = searchTerm.trim();
  if (!trimmed) return vendedores;

  const trimmedLower = trimmed.toLowerCase();
  return vendedores.filter((vendedor) => {
    const matchesNumber = String(vendedor.nroVendedor).includes(trimmed);
    const matchesName = vendedor.nombreVendedor?.toLowerCase().includes(trimmedLower);
    return matchesNumber || matchesName;
  });
};

export const sortVendedoresByName = (vendedores: VendedorLike[]): VendedorLike[] =>
  [...vendedores].sort((a, b) =>
    String(a.nombreVendedor ?? '').localeCompare(String(b.nombreVendedor ?? ''), 'es')
  );
